import * as http from 'axios'
export const getExames = (q) =>
  http.get(`/exames?sort=nomeExame&nomeExame__regex=/.*${q}.*/i`)



// WEBPACK FOOTER //
// ./src/store/exameRede/services.js